module.exports = __webpack_public_path__ + "img/block2.cee8f459.png";